(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktopFooter = window.matchMedia('(min-width: 700px)');
  const lifecycle = new AbortController();

  const findInScope = (scope, selector) => {
    if (scope instanceof Element && scope.matches(selector)) return scope;
    return scope.querySelector?.(selector) || null;
  };

  const syncFooterDetails = (footer) => {
    footer.querySelectorAll('.avf-links').forEach((details) => {
      if (desktopFooter.matches) {
        details.open = true;
      } else if (details.dataset.avfTouched !== 'true') {
        details.open = false;
      }
    });
  };

  const initHeader = (header) => {
    header.avonticLuxuryCleanup?.();

    const controller = new AbortController();
    const signal = controller.signal;
    let frame = 0;
    let compact = null;
    let resizeObserver = null;
    let cartObserver = null;

    const syncHeader = () => {
      frame = 0;
      const next = compact === true ? window.scrollY > 30 : window.scrollY > 88;
      if (next === compact) return;
      compact = next;
      header.classList.toggle('avontic-header--compact', next);
      header.dataset.headerState = next ? 'compact' : 'full';
    };

    const requestSync = () => {
      if (!frame) frame = window.requestAnimationFrame(syncHeader);
    };

    const syncCart = () => {
      header.querySelectorAll('.avontic-cart-badge').forEach((badge) => {
        const count = Number.parseInt(badge.textContent.trim(), 10) || 0;
        badge.classList.toggle('is-empty', count < 1);
        badge.setAttribute('aria-hidden', count < 1 ? 'true' : 'false');
      });
    };

    syncHeader();
    syncCart();
    window.addEventListener('scroll', requestSync, { passive: true, signal });

    const section = header.closest('.shopify-section--header');
    if (section && 'ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--header-height', section.clientHeight.toFixed(2) + 'px');
      });
      resizeObserver.observe(section);
    }

    cartObserver = new MutationObserver(syncCart);
    cartObserver.observe(header, { childList: true, characterData: true, subtree: true });

    header.dataset.avonticReady = 'true';
    header.avonticLuxuryCleanup = () => {
      controller.abort();
      resizeObserver?.disconnect();
      cartObserver?.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      delete header.dataset.avonticReady;
      delete header.avonticLuxuryCleanup;
    };
  };

  const initFooter = (footer) => {
    footer.avonticLuxuryCleanup?.();

    const controller = new AbortController();
    const signal = controller.signal;

    footer.querySelectorAll('.avf-links').forEach((details) => {
      details.addEventListener(
        'toggle',
        () => {
          if (!desktopFooter.matches) details.dataset.avfTouched = 'true';
        },
        { signal }
      );
    });

    syncFooterDetails(footer);
    footer.dataset.avonticReady = 'true';
    footer.avonticLuxuryCleanup = () => {
      controller.abort();
      delete footer.dataset.avonticReady;
      delete footer.avonticLuxuryCleanup;
    };
  };

  const init = (scope = document) => {
    const header = findInScope(scope, '[data-avontic-header]');
    const footer = findInScope(scope, '[data-avontic-footer]');

    if (header) initHeader(header);
    if (footer) initFooter(footer);

    if (reducedMotion.matches) {
      scope.querySelectorAll?.('announcement-bar-carousel[autoplay]').forEach((carousel) => {
        carousel.removeAttribute('autoplay');
      });
    }
  };

  const cleanup = (scope) => {
    findInScope(scope, '[data-avontic-header]')?.avonticLuxuryCleanup?.();
    findInScope(scope, '[data-avontic-footer]')?.avonticLuxuryCleanup?.();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true, signal: lifecycle.signal });
  } else {
    init();
  }

  desktopFooter.addEventListener(
    'change',
    () => {
      const footer = document.querySelector('[data-avontic-footer]');
      if (footer) syncFooterDetails(footer);
    },
    { signal: lifecycle.signal }
  );

  document.addEventListener('shopify:section:load', (event) => init(event.target), { signal: lifecycle.signal });
  document.addEventListener('shopify:section:unload', (event) => cleanup(event.target), { signal: lifecycle.signal });
})();

(() => {
  if (window.AvonticCartAssuranceLabels) return;

  const titles = Object.freeze(['Fast Free Shipping', '60 Day Free Returns']);
  let frame = 0;

  const sync = () => {
    frame = 0;
    const cards = document.querySelectorAll('#cart-drawer .avc-fulfillment > a');

    titles.forEach((title, index) => {
      const card = cards[index];
      if (!card) return;

      const label = card.querySelector('strong');
      if (label && label.textContent.trim() !== title) label.textContent = title;

      card.querySelector('small')?.remove();
      card.querySelector('.avc-fulfillment__mark')?.remove();
      card.style.gridTemplateColumns = 'minmax(0, 1fr)';
      card.style.justifyItems = 'center';
      card.style.alignItems = 'center';
      card.style.textAlign = 'center';
    });
  };

  const requestSync = () => {
    if (!frame) frame = window.requestAnimationFrame(sync);
  };

  const observer = new MutationObserver((mutations) => {
    const drawerChanged = mutations.some((mutation) => {
      if (mutation.target instanceof Element && mutation.target.closest('#cart-drawer')) return true;

      return [...mutation.addedNodes].some((node) => (
        node instanceof Element
        && (
          node.matches('#cart-drawer, #cart-drawer *')
          || node.querySelector('#cart-drawer .avc-fulfillment')
        )
      ));
    });

    if (drawerChanged) requestSync();
  });

  const start = () => {
    if (!document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
    requestSync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', requestSync);
  document.addEventListener('cart:refresh', requestSync);
  document.addEventListener('cart:change', requestSync);

  window.AvonticCartAssuranceLabels = Object.freeze({ sync });
})();
